$(function () {
	$(".tickergallery .item:visible").each(function () {
		var n = Math.floor(Math.random() * (5)) + 2;
		var $el = $(this);
		setInterval(function () {
			changeSrc( $el );
		}, n * 1000);
	});

});

function changeSrc( $el ) {

		$data = $el.data("params");
		var validSRC = $.extend(true, [], $data);
		// console.log(validSRC);
		for (var i = 0; i < validSRC.length; i++) {
			if (validSRC[i]["active"] === true) {
				validSRC.splice(i, 1);
			}
		}

		var randomINDEX = Math.floor(Math.random() * validSRC.length);
		validSRC[randomINDEX]["active"] = true;

		$el
			.find("img:hidden")
			.attr("src", validSRC[randomINDEX]["src"])
			.attr("data-index", randomINDEX);
			
		
		$el.find("img").each(function () {
				if ($(this).is(":visible")) {
					$(this).fadeOut(1500, function () {
						$data[$(this).data("index")]["active"] = false;
					});
				} else {
					$(this).fadeIn(1500);
				}
			
	});
}
